 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOPY from '@/components/Text/copy'
 import TEXTDEDI from '@/components/Text/dedi'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTINTRO from '@/components/Text/intro'
 import TEXTCH1 from '@/components/Text/ch1'
 import TEXTCH2 from '@/components/Text/ch2'
 import TEXTCH3 from '@/components/Text/ch3'
 import TEXTCH4 from '@/components/Text/ch4'
 import TEXTCH5 from '@/components/Text/ch5'
 import TEXTCH6 from '@/components/Text/ch6'
 import TEXTCH7 from '@/components/Text/ch7'
 import TEXTCH8 from '@/components/Text/ch8'
 import TEXTCH9 from '@/components/Text/ch9'
 import TEXTCH10 from '@/components/Text/ch10'
 import TEXTCH11 from '@/components/Text/ch11'
 import TEXTCH12 from '@/components/Text/ch12'
 import TEXTCH13 from '@/components/Text/ch13'
 import TEXTCH14 from '@/components/Text/ch14'
 import TEXTCH15 from '@/components/Text/ch15'
 import TEXTCH16 from '@/components/Text/ch16'
 import TEXTCH17 from '@/components/Text/ch17'
 import TEXTCH18 from '@/components/Text/ch18'
 import TEXTCH19 from '@/components/Text/ch19'
 import TEXTCH20 from '@/components/Text/ch20'
 import TEXTCH21 from '@/components/Text/ch21'
 import TEXTCONCL from '@/components/Text/concl'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTGLOSSARY from '@/components/Text/glossary'
 import TEXTFURTHER from '@/components/Text/further'
 import TEXTAUTHORINDEX from '@/components/Text/authorindex'
 import TEXTSUBJECTINDEX from '@/components/Text/subjectindex'
 import TEXTSCRIPTUREINDEX from '@/components/Text/scriptureindex'
 import TEXTPRAISE from '@/components/Text/praise'
 import TEXTABOUT from '@/components/Text/about'
 import TEXTMOREIVP from '@/components/Text/moreivp'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/intro",
 			"name" : "Text/intro",
 			"component" : TEXTINTRO
 		},
 		{
 			"path" : "/Text/ch1",
 			"name" : "Text/ch1",
 			"component" : TEXTCH1
 		},
 		{
 			"path" : "/Text/ch2",
 			"name" : "Text/ch2",
 			"component" : TEXTCH2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js